module.exports = __webpack_public_path__ + "img/th_helmo.0680aa13.jpg";